import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { pageAnimation, WaveAnimation } from "./Animation";

const Wave = () => {
  return (
    <WaveWrapper>
      <WaveSVG
        viewBox="0 0 1440 363"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        initial="hidden"
        animate="show"
        variants={pageAnimation}
      >
        <motion.path
          variants={WaveAnimation}
          d="M1440 27.4774C1352.73 19.8184 1122.41 49.0556 899.331 227.276C620.48 450.052 354.282 355.647 170.328 185.318C23.165 49.0556 -4.21721 8.32998 0.487081 5"
          stroke="#c562c5"
          strokeOpacity="0.8"
          strokeWidth="10"
        />
      </WaveSVG>
    </WaveWrapper>
  );
};

const WaveWrapper = styled(motion.div)`
  @media screen and (max-width: 520px) {
    display: none;
  }
`;

const WaveSVG = styled(motion.svg)`
  z-index: -1;
  position: absolute;
  left: 0;
  top: 18rem;
`;

export default Wave;
